const MONTHS = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

/**
 * «16 августа 2026» — один формат на реестр и на окно подтверждения.
 *
 * Дата разблокировки в окне и колонка «Вывод из стейкинга» в таблице — одна и
 * та же величина в глазах оператора. Два массива месяцев в двух файлах
 * разъехались бы при первой же правке.
 */
export const formatDate = (value) => {
  const date = value instanceof Date ? value : new Date(value);

  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
};

export default formatDate;
